module.exports = __webpack_public_path__ + "static/media/112.98fefdc6.png";